import React, { useState, useContext } from 'react';
import { ethers } from 'ethers';
import { Box, Button, Heading, Input, Select, Text } from '@chakra-ui/react';
import { AppContext } from '../../AppContext';
import JakobWallet from '../../contracts/JakobWallet.json';
//import { frax } from '../../config';

const ApproveTokenSpending = ({   setStatus }) => {
  const { account, contractAddress } = useContext(AppContext);
  const [tokenAmount, setTokenAmount] = useState('');
  //const [status, setStatus] = useState('');
  const [selectedToken, setSelectedToken] = useState('USDC_ADDRESS');

  const contractABI = JakobWallet.abi;

  const tokenAddressMap = {
    USDC_ADDRESS: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    USDCE_ADDRESS: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
    USDT_ADDRESS: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    LINK_ADDRESS: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
  //  FRAX_ADDRESS: frax,
    ETH_ADDRESS: ethers.constants.AddressZero,
    WETH_ADDRESS: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    WBTC_ADDRESS: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
  };

  const handleApproveTokenSpending = async () => {
    if (!tokenAmount || isNaN(tokenAmount) || Number(tokenAmount) <= 0) {
      setStatus('Please enter a valid amount.');
      return;
    }

    try {
      const amountInWei = ethers.utils.parseUnits(tokenAmount, 6);
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddress, contractABI, signer);
      const tokenAddress = tokenAddressMap[selectedToken];

      const tx = await contract.approveTokenSpending(tokenAddress, amountInWei);
      setStatus(`Approving ${selectedToken} spending...`);
      await tx.wait();
      setStatus(`${selectedToken} spending approved successfully!`);
    } catch (error) {
      console.error(`Error approving ${selectedToken} spending:`, error);
      setStatus(`Error approving ${selectedToken} spending.`);
    }
  };

  return (
    <Box p={4} mb={2}>
      <Heading as="h3" size="md">Approve Token Spending</Heading>
      <Select
        value={selectedToken}
        onChange={(e) => setSelectedToken(e.target.value)}
        backgroundColor="white"
        marginBottom="10px"
      >
        {Object.keys(tokenAddressMap).map((tokenKey) => (
          <option key={tokenKey} value={tokenKey}>
            {tokenKey.replace('_ADDRESS', '')}
          </option>
        ))}
      </Select>
      <Input
        type="text"
        value={tokenAmount}
        onChange={(e) => setTokenAmount(e.target.value)}
        placeholder="Amount"
        backgroundColor="white"
      />
      <Button colorScheme="blue" width="100%" onClick={handleApproveTokenSpending}>
        Approve {selectedToken.replace('_ADDRESS', '')} Spending
      </Button>
    </Box>
  );
};

export default ApproveTokenSpending;
